import React from 'react';
import { withRouter } from 'react-router';
import Layout from './components/layout/Layout';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true
        })
    }

    componentDidUpdate() {
        if (!this.state.hasError) {
            return;
        }

        this.props.history.listen(() => {
            this.setState((currentState) => ({
                ...currentState,
                hasError: false,
            }));
        });
    }


    render() {
        if (this.state.hasError) {
            return (
                <Layout>
                    <h1 className="heading">Something went wrong. Please try again later.</h1>
                </Layout>
            );
        }

        return this.props.children;
    }
}

export default withRouter(ErrorBoundary);